import { IUserSettingsAction } from '../userSettings';

export const SET_SELECTED_CUSTOMERS =
  'opus/user/customer/SET_SELECTED_CUSTOMERS';

export default function reducer(
  state: Record<string, unknown>,
  action: IUserSettingsAction
): Record<string, unknown> {
  switch (action.type) {
    case SET_SELECTED_CUSTOMERS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
